// The narrowing of a loose value to a member of a fixed list. It is a leaf
// with no import.

/**
 * `v` as a member of `list` when the list holds it, else undefined: a
 * stored setting, an address word or a `data-` attribute of a pressed
 * element, read against the list that this build carries. A caller with a
 * default writes `oneOf(list, v) ?? fallback`.
 */
export function oneOf<T>(list: readonly T[], v: unknown): T | undefined {
  return list.includes(v as T) ? v as T : undefined;
}
